import {Component, inject} from '@angular/core';
import {Location} from "@angular/common";

@Component({
  selector: 'app-back-button',
  imports: [],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.css'
})
export class BackButtonComponent {
  
  private location = inject(Location);

  back(): void {
    this.location.back();
  }
}
